/**
 * 数组去重
 * @param {type} data 数组. 
 * @param {type} symbol 通过哪个字段去判断. 
 */
function arrayUniq(data, symbol) {
    let obj = {};
    for (let i = 0, len = data.length; i < len; i++) {
        let item = data[i],
            key = item[symbol];
        if (obj[key]) {
            obj[key].push(item)
        } else {
            obj[key] = [item]
        }
    }
    return obj
}


export {
    arrayUniq
};


// WEBPACK FOOTER //
// ./src/mixins/methods/listUniq.js